import React, { useCallback, useState } from "react";
import { SingleValue } from "react-select";
import { SearchRefraction } from "@untitled-ui/icons-react";
import { AdvancedSelect } from "@myhealth-raccoon/components";

import { SuburbOptionType, suburbs } from "."
import { useDebounce } from "src/hooks/useDebounce";

type Props = {
    onChange(selectedOption: SuburbOptionType | SingleValue<SuburbOptionType>): void;
    postcode?: string;
    suburb?: string;
    error?: boolean;
}

function filterOption(suburb: SuburbOptionType, searchTerm: string): boolean {
    return !!searchTerm
        .split(' ')
        .find(term => [
            suburb.postcode.includes(term),
            suburb.suburb.toUpperCase().includes(term.toUpperCase())
        ].filter(x => x).length)
}

function termsMatched(suburb: SuburbOptionType, searchTerm: string): number {
    return searchTerm
        .split(' ')
        .filter(term => [
            suburb.postcode.includes(term),
            suburb.state.toUpperCase().includes(term.toUpperCase()),
            suburb.suburb.toUpperCase().includes(term.toUpperCase())
        ].filter(x => x).length)
        .length
}

export function SuburbSelect({ onChange, postcode, suburb, error }: Props) {

    const [searchedSuburbs, setSearchedSuburbs] = useState<SuburbOptionType[]>([]);
    const searchSuburbs = useDebounce(useCallback((searchTerm: string) => {
        if (searchTerm) {
            setSearchedSuburbs(suburbs
                .filter(suburb => filterOption(suburb, searchTerm))
                .sort((a, b) => termsMatched(b, searchTerm) - termsMatched(a, searchTerm))
                .slice(0, 20)
            );
        }
    }, []), 300);

    return <AdvancedSelect<SuburbOptionType, false>
        error={error}
        filterOption={({ data }, term) => filterOption(data, term)}
        options={searchedSuburbs}
        isOptionSelected={(sub) => postcode === sub.postcode && suburb === sub.suburb}
        value={suburbs.find((sub) => postcode === sub.postcode && suburb === sub.suburb)}
        onChange={onChange}
        onInputChange={searchSuburbs}
        placeholder="Address Suburb/State..."
        isClearable
        Icon={SearchRefraction}
        closeMenuOnSelect
    />;

}